import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{staticClass:"mini",attrs:{"value":_vm.value,"items":_vm.items,"hide-details":"auto","label":"Equipment type","outlined":"","dense":"","clearable":"","return-object":"","item-text":"name","item-value":"id"},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }